import React from 'react';
import ReactDOM from 'react-dom';

// eslint-disable-next-line
import Symbol_observable from 'symbol-observable';

import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { PersistGate } from 'redux-persist/integration/react';

import * as serviceWorker from './service-worker';
import { configureStore } from './store/configure-store';
import { configureApi } from './api';
import configureIcons from './components/Icons/configure-icons';

import { HistoryContext, history } from './contexts/HistoryContext';

import 'styles/site.scss';

import Routes from './routes';

import { ScrollToTop } from './components';
import Alerts from './containers/Alerts';
import GlobalSvgMasks from './components/Charts/GlobalSvgMasks';

configureIcons();

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = window.initialReduxState || {};
const { store, persistor } = configureStore(history, initialState);

configureApi({
  getAuthToken: () => store.getState().identity.token,
  getCurrentWorkspaceId: () => store.getState().currentWorkspaceId,
});

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <HistoryContext.Provider value={history}>
        <ConnectedRouter history={history}>
          <ScrollToTop>
            <Alerts />
            <Routes history={history} />
          </ScrollToTop>
        </ConnectedRouter>
      </HistoryContext.Provider>
    </PersistGate>
    <GlobalSvgMasks />
  </Provider>,
  document.getElementById('react-app')
);

serviceWorker.unregister();
